(function () {
    'use strict';

    // Directives related to triggers
    angular.module('GorillaBoy.Analytics')
    .directive('relayEventsOnActivityItem', ['SignalProvider', function(SignalProvider) {
        return {
            restrict: 'A',
            link : function($scope, $element, $attrs) {
                $element.on('click', function(evt) {
                    var $target = $(evt.target);
                    if (!$target.is(".filter-link")) {
                        return;
                    }
                    //When emitting events, $evalAsync is not working so it's necessary to kick off $digest() loop manually
                    if ($target.is(".initiator-actor-name")) {
                        $scope.$apply(function() {
                            $scope.$emit(SignalProvider.ActivityFeed.FilterByInitiatorActor, $scope.activity);
                        });
                    } else if ($target.is(".target-actor-name")) {
                        $scope.$apply(function() {
                            $scope.$emit(SignalProvider.ActivityFeed.FilterByTargetActor, $scope.activity);
                        });
                    } else if ($target.is(".comment-recipient-name")) {
                        $scope.$apply(function() {
                            $scope.$emit(SignalProvider.ActivityFeed.FilterByCommentRecipient, $scope.activity);
                        });
                    }
                });
            }
        };
    }]);

}());
